module.exports = __webpack_public_path__ + "img/bg-auth.cace070b.svg";